export const OPTIMIZELY_TESTS_KEYS = {
  PROMOTED_SLIDER_PDP: 'ID_408_Promoted_Slider_on_PDP',
  VIDEO_PDP: 'ID_410_video_on_pdp',
  BLACK_FRIDAY_COUNTDOWN: 'ID_452_black_friday_countdown',
  FOLLOW_UP_SPLIT_PACKAGES: 'ID_453_follow_up_split_package_parts_sz',
  SHOW_MANDATORY_PAYMENT_PAGE: 'id_483_show_mandatory_payment_uds_external_flights',
  SORT_ORDER_PERSONALIZATION: 'ID_465_sort_order_personalisation_sz',
  REPHRASE_DISCOUNTS: 'ID_469_rephrase_discounts',
  MANDATORY_PAYMENT_PAGE_UDS: 'id_482_mandatory_payment_uds',
  ALTERNATE_FLIGHT_VISUALISATION: 'ID_480_alternate_flight_visualisation',
} as const

export type OPTIMIZELY_TESTS_KEY = keyof typeof OPTIMIZELY_TESTS_KEYS
export type OPTIMIZELY_TESTS_KEY_VALUE = typeof OPTIMIZELY_TESTS_KEYS[OPTIMIZELY_TESTS_KEY]

export type AbTests = Partial<Record<OPTIMIZELY_TESTS_KEY, boolean>>
